import {createClient} from 'contentful';

export default createClient({
  space: "y7d50sg6fa73",
  accessToken: "W7fqJEarYOIb7XHc4e-2QRRZtSstN-tfTBYbh-E7B40"
});



// const config = {
//   spaceId: process.env.CONTENTFUL_SPACE_ID,
//   deliveryToken: process.env.CONTENTFUL_ACCESS_TOKEN
// };

// export default createClient({
//   space: config.spaceId,
//   accessToken: config.deliveryToken
// });